module.exports = __webpack_public_path__ + "static/media/006.dc5f74f7.jpg";